/** 页面信息 */
const page = new (function () {
  this.title = '填报单位联系人'
  this.icon = 'iconfont iconicon_group'
  this.name = 'register_unitContact'
  /**菜单编号 */
  this.code = 'register_unitContact'
  /**菜单别名 */
  this.aliasName = 'register_unitContact'
  /**路由地址 */
  this.path = '/register/unitContact'
})()

/** 路由信息 */
export const route = {
  page,
  component: () => import('./index.vue')
}

export default page
